<template>
    <div class="m-rec" v-if="rec_list.length && $store.state.userinfo.uid && $store.state.userinfo.zid">
        <div class="title"></div>

        <div class="rec-view">
            <div class="rec-pannel">
                <div class="pannel-body"></div>
                <div class="pannel-content">
                    <ul>
                        <li v-for="(item,index) in rec_list" :key="index">
                            <div class="name">
                                <p>{{ shop_dic[item.sid].name || '' }}</p>
                                <div class="discount-info">{{ shop_dic[item.sid].discount }}</div>
                            </div>

                            <div class="item-detail">
                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                    </div>  
                                </div>                                
                                
                                <div class="price-info">
                                    <h6 class="item-name">{{ item.giftName }}</h6>
                                    <div class="low">最低价<em class="icon-m3b"></em><span>{{ item.minPrice }}</span><span class="p-before">{{ item.maxPrice }}</span></div>
                                    <div class="now">当前价<em class="icon-m3b"></em><span>{{ item.price }}</span></div>                                           
                                </div>
                            </div>

                            <div class="u-btn apply" @click="call_cut(item)"></div>
                        </li>
                    </ul>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
import shop_group from '@/components/shopgroup.js'

export default {
    data () {
        return {
            shop_dic : shop_group.shop_dic,
            rec_list : [],
            sid : 1,
        }
    },
    mounted (){
        this.render();
    },
    props :{
        shop_view : {
            default : false,
        }
    },
    methods : {
        render (){
            this.render_default();
        },
        render_default (){
            if(!this.$store.state.userinfo.uid || !this.$store.state.userinfo.zid)return;

            this.$get(ajax_url_map.rec_list,{
                success : (data) => {
                    this.rec_list = data.data;
                }
            })
        },
        render_basket (){
            this.$get(ajax_url_map.basket_list,{
                success : (data) => {
                    this.$store.commit("$_setBasket", data.data.data);
                }
            })
        },             
        render_shop(){
            //todo
        },
        call_cut(item){

            if(!item.giftId){
                throw new Error('缺少商品ID');
            }

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            this.$post(ajax_url_map.add_basket,{
                success : (data) => {
                    //let shareTxt = data.data.koudai + this.$store.state.userinfo.nickName + '阿斗测试分享' + data.data.shopName + data.data.price + ' ' + data.data.url;
                    let shareTxt = this.$global.share_format({...data.data,nickName : this.$store.state.userinfo.nickName});
                    this.$copy_modal({ shareTxt : shareTxt });
                    this.render();

                    this.shop_view ? this.render_basket () : '';
                },
                error : (data) => {
                    this.$toast(data.message);
                }                
            },{
                id : item.id,
            })
        },          
    },
}
</script>

<style lang="scss" scoped>
.title{
    width: 750px;
    height: 77px;
    margin: 0 auto;
    background-image: url(~@/assets/images/title-rec.png);
}

.rec-view{
    position: relative;
    padding-top: 30px;
    margin-bottom: 28px;

    &::before{
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 483px;
        height: 44px;
        background-image: url(~@/assets/images/basket/shop-top.png);
    }
}

.rec-pannel{
    position: relative;
    width: 690px;       
    margin: 0 auto;
    background: url(~@/assets/images/task/pannel-head.png) center top no-repeat,
                url(~@/assets/images/task/pannel-footer.png) center bottom no-repeat;
    background-size: 100% auto;

    .pannel-body{
        position: absolute;
        left:0;
        top:38px;
        bottom:38px;
        width:100%;
        background: url(~@/assets/images/task/pannel-body.png) left top repeat-y;
        background-size: 100% auto;          
    }

    .pannel-content{
        position: relative;
        // min-height: 400px;
        padding: 25px 24px 22px;
        color: #7f572d;
    }

    ul{
        padding: 0 22px;

        li{
            position: relative;

            .u-btn{
                position: absolute;
                right: 0;
                top: 80px;
            }
        }
        
        .name p{
            font-size: 28px;
            font-weight: 700;
            color: #7f572d;
        }        
    }

}

.goods-detail{
    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 118px;
        height: 118px;
        background-image: url(~@/assets/images/shop/bg-item.png);
    }

    .goods-pic{
        width: 69px;
        height: 69px;
        border: 2px solid #ccae62;
    }
}


.u-btn.apply{
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/basket/btn-apply.png);

    &.disabled{
        background-image: url(~@/assets/images/basket/btn-apply_disabled.png);
    }      
}

.item-detail{
    display: flex;
    align-items: center;
    padding-right: 180px;

    .price-info{
        margin-left: 20px;

        .item-name{
            margin-bottom: 10px;
            font-weight: 700;
            color: #7f572d;
            font-size: 24px;
        }

        .icon-m3b {
            display: inline-block;
            width: 26px;
            height: 26px;
            background-image: url(~@/assets/images/icon-m3b.png);
            // vertical-align: middle;
        }

        .low {
            color: #683d1e;
        }

        .now {
            color: #683d1e;
        }

        .now span {
            font-size: 28px;
            font-weight: 700;
            color: #d33d27;
        }

        .p-before {
            padding-left: 8px;
            color: #ad7239;
            text-decoration: line-through;
        }

    }
}
</style>